import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORM_URL } from 'app/@common/constants'

export default function SelectFrequency({...props}) {

    const myProps = {
        urlAjax: FORM_URL.FREQUENCY,
        placeholder: i18n.t('common:filters.frequency'),
        icon: {icon: 'watch'},
        isMulti: false,
        isClearable: true,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
